export function linkify({ href, text }, cssClass = "text-general-hyperlink") {
    return `<a class="${cssClass}" rel="noopener noreferrer" target="_blank" href="${href}">${text}</a>`;
}
export function mailtoLink(email, cssClass) {
    return linkify({
        text: email,
        href: `mailto:${email}`,
    }, cssClass);
}
export function learnMoreLink(href, cssClass) {
    return linkify({ text: "Learn more", href }, cssClass);
}
export const SUPPORT_EMAIL = "support@tastytrade.com";
export const MAIL_TO_SUPPORT = `mailto:${SUPPORT_EMAIL}`;
export const MAIL_TO_SUPPORT_LINK = mailtoLink(SUPPORT_EMAIL);
export const BANKING_EMAIL = "banking@tastytrade.com";
export const MAIL_TO_BANKING = `mailto:${BANKING_EMAIL}`;
export const MAIL_TO_BANKING_LINK = mailtoLink(BANKING_EMAIL);
export const ACCOUNTS_EMAIL = "accounts@tastytrade.com";
export const MAIL_TO_ACCOUNTS = `mailto:${ACCOUNTS_EMAIL}`;
export const MAIL_TO_ACCOUNTS_LINK = mailtoLink(ACCOUNTS_EMAIL);
export const SUPPORT_CONTACT_PAGE = "https://support.tastytrade.com/support/s/solutions/articles/43000476860";
export const SUPPORT_PHONE_NUMBER = `+13127247075`;
export const SUPPORT_PHONE_NUMBER_LINK = `<a class="text-general-hyperlink" href="tel:${SUPPORT_PHONE_NUMBER}">(312) 724-7075</a>`;
export const RTP_HELP_CENTER = "https://support.tastytrade.com/support/s/solutions/articles/Real-Time-Payments";
export const RTP_HELP_CENTER_LINK = learnMoreLink(RTP_HELP_CENTER);
export const TAX_WITHHOLDINGS_HELP_CENTER = "https://support.tastytrade.com/support/s/solutions/articles/43000472762";
export const TAX_WITHHOLDINGS_HELP_CENTER_LINK = `<a rel="noopener noreferrer" target="_blank" href="${TAX_WITHHOLDINGS_HELP_CENTER}">Learn more</a>`;
export const RISK_DISCLOSURE_URL = "https://zerohash.zendesk.com/hc/en-us/articles/28327983001235-General-Risks-of-Digital-Assets";
export const IRA_CONTRIBUTION_LIMITS_HELP_CENTER = "https://support.tastytrade.com/support/s/solutions/articles/43000435268";
export const WEB_PLATFORM_SOURCE_IDENTIFIER = "WB2";
export const ELECTRON_PLATFORM_SOURCE_IDENTIFIER = "ELECTRON";
export const LOGIN_MESSAGE_KEY = "login-message";
export var ACCOUNT_TYPES;
(function (ACCOUNT_TYPES) {
    ACCOUNT_TYPES["BENEFICIARY_ROTH_IRA"] = "Beneficiary Roth IRA";
    ACCOUNT_TYPES["BENEFICIARY_TRADITIONAL_IRA"] = "Beneficiary Traditional IRA";
    ACCOUNT_TYPES["INDIVIDUAL"] = "Individual";
    ACCOUNT_TYPES["JOINT_TENANTS_IN_COMMON"] = "Joint Tenants in Common";
    ACCOUNT_TYPES["JOINT_WROS"] = "Joint Tenants with Rights of Survivorship";
    ACCOUNT_TYPES["ROTH_IRA"] = "Roth IRA";
    ACCOUNT_TYPES["SEP_IRA"] = "SEP";
    ACCOUNT_TYPES["TRADITIONAL_IRA"] = "Traditional IRA";
    ACCOUNT_TYPES["BUSINESS"] = "Business";
    ACCOUNT_TYPES["C_CORP"] = "C. Corp";
    ACCOUNT_TYPES["S_CORP"] = "S. Corp";
    ACCOUNT_TYPES["LLC"] = "LLC";
    ACCOUNT_TYPES["PARTNERSHIP"] = "Partnership";
    ACCOUNT_TYPES["TRUST"] = "Trust";
})(ACCOUNT_TYPES || (ACCOUNT_TYPES = {}));
export var ALLOCATION_STYLES;
(function (ALLOCATION_STYLES) {
    ALLOCATION_STYLES["PER_TRADE"] = "Per Trade";
    ALLOCATION_STYLES["UNIT"] = "Unit";
})(ALLOCATION_STYLES || (ALLOCATION_STYLES = {}));
export var ALLOCATION_METHODS;
(function (ALLOCATION_METHODS) {
    ALLOCATION_METHODS["BUYING_POWER_PERCENTAGE"] = "Buying Power Percentage";
    ALLOCATION_METHODS["CONTRACT_QUANTITY"] = "Contract Quantity";
    ALLOCATION_METHODS["DOLLAR_AMOUNT"] = "Dollar Amount";
    ALLOCATION_METHODS["UNIT_COUNT"] = "Unit Count";
})(ALLOCATION_METHODS || (ALLOCATION_METHODS = {}));
export var WITHHOLDING_TYPES;
(function (WITHHOLDING_TYPES) {
    WITHHOLDING_TYPES["PERCENT"] = "PERCENTAGE";
    WITHHOLDING_TYPES["FIXED"] = "FIXED";
})(WITHHOLDING_TYPES || (WITHHOLDING_TYPES = {}));
export var CHECK_DELIVERY_METHODS;
(function (CHECK_DELIVERY_METHODS) {
    CHECK_DELIVERY_METHODS["OVERNIGHT"] = "Overnight";
    CHECK_DELIVERY_METHODS["STANDARD"] = "Standard";
})(CHECK_DELIVERY_METHODS || (CHECK_DELIVERY_METHODS = {}));
export var COMMUNICATION_GROUP;
(function (COMMUNICATION_GROUP) {
    /** @deprecated */
    COMMUNICATION_GROUP["ACCOUNT"] = "Account Communications";
    /** @deprecated */
    COMMUNICATION_GROUP["TRADE"] = "Trade Communications";
    /** @deprecated */
    COMMUNICATION_GROUP["MARKETING"] = "Marketing Communications";
    /** @deprecated */
    COMMUNICATION_GROUP["REFERRAL"] = "Referral Communications";
    /** @deprecated */
    COMMUNICATION_GROUP["CASH"] = "Cash Communications";
    /** @deprecated */
    COMMUNICATION_GROUP["ORDER_FILL_NOTIFICATIONS"] = "Order Fill Notifications";
    // Reworked Communication Groups
    COMMUNICATION_GROUP["SECURITY"] = "Security";
    COMMUNICATION_GROUP["ACCOUNT_MANAGEMENT"] = "Account Management";
    COMMUNICATION_GROUP["ANNOUNCEMENTS"] = "Announcements";
    COMMUNICATION_GROUP["MARKET_NEWS"] = "Market News";
    COMMUNICATION_GROUP["PROMOTIONS"] = "Promotions";
    COMMUNICATION_GROUP["EDUCATION"] = "Education";
    COMMUNICATION_GROUP["FEEDBACK"] = "Feedback";
    COMMUNICATION_GROUP["MARGIN_AND_RISK"] = "Margin & Risk";
    COMMUNICATION_GROUP["ORDER_FILLS"] = "Order Fills";
    COMMUNICATION_GROUP["POSITION_ALERTS"] = "Position Alerts";
    COMMUNICATION_GROUP["PRICE_ALERTS"] = "Price Alerts";
    // only used for initialization
    COMMUNICATION_GROUP["BLANK"] = "";
})(COMMUNICATION_GROUP || (COMMUNICATION_GROUP = {}));
export var CUSTOMER_ACCOUNT_AUTHORITY_LEVELS;
(function (CUSTOMER_ACCOUNT_AUTHORITY_LEVELS) {
    CUSTOMER_ACCOUNT_AUTHORITY_LEVELS["OWNER"] = "owner";
    CUSTOMER_ACCOUNT_AUTHORITY_LEVELS["READ_ONLY"] = "read-only";
    CUSTOMER_ACCOUNT_AUTHORITY_LEVELS["TRADE_ONLY"] = "trade-only";
})(CUSTOMER_ACCOUNT_AUTHORITY_LEVELS || (CUSTOMER_ACCOUNT_AUTHORITY_LEVELS = {}));
export var DIGITAL_ASSET_DEPOSIT_STATUSES;
(function (DIGITAL_ASSET_DEPOSIT_STATUSES) {
    DIGITAL_ASSET_DEPOSIT_STATUSES["NEEDS_MANUAL_RETURN"] = "Needs Manual Return";
    DIGITAL_ASSET_DEPOSIT_STATUSES["RETURN_SUBMITTED_TO_CLEARING"] = "Return Submitted to Clearing";
    DIGITAL_ASSET_DEPOSIT_STATUSES["RETURNED"] = "Returned";
    DIGITAL_ASSET_DEPOSIT_STATUSES["SETTLED"] = "Settled";
    DIGITAL_ASSET_DEPOSIT_STATUSES["UNDER_REVIEW"] = "Under Review";
})(DIGITAL_ASSET_DEPOSIT_STATUSES || (DIGITAL_ASSET_DEPOSIT_STATUSES = {}));
export var DIGITAL_ASSET_WITHDRAWAL_STATUSES;
(function (DIGITAL_ASSET_WITHDRAWAL_STATUSES) {
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["AWAITING_EXECUTION"] = "Awaiting Execution";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["EXPIRED"] = "Expired";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["CLEARING_APPROVED"] = "Clearing Approved";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["CLEARING_PROCESSED"] = "Clearing Processed";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["CLEARING_REJECTED"] = "Clearing Rejected";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["CLEARING_SETTLED"] = "Clearing Settled";
    DIGITAL_ASSET_WITHDRAWAL_STATUSES["SUBMITTED_TO_CLEARING"] = "Submitted to Clearing";
})(DIGITAL_ASSET_WITHDRAWAL_STATUSES || (DIGITAL_ASSET_WITHDRAWAL_STATUSES = {}));
export const EN_COUNTRY_LABELS = {
    ABW: "Aruba",
    AFG: "Afghanistan",
    AGO: "Angola",
    AIA: "Anguilla",
    ALA: "Åland Islands",
    ALB: "Albania",
    AND: "Andorra",
    ARE: "United Arab Emirates",
    ARG: "Argentina",
    ARM: "Armenia",
    ASM: "American Samoa",
    ATA: "Antarctica",
    ATF: "French Southern Territories",
    ATG: "Antigua and Barbuda",
    AUS: "Australia",
    AUT: "Austria",
    AZE: "Azerbaijan",
    BDI: "Burundi",
    BEL: "Belgium",
    BEN: "Benin",
    BES: "Bonaire (Sint Eustatius and Saba)",
    BFA: "Burkina Faso",
    BGD: "Bangladesh",
    BGR: "Bulgaria",
    BHR: "Bahrain",
    BHS: "Bahamas",
    BIH: "Bosnia and Herzegovina",
    BLM: "Saint Barthélemy",
    BLR: "Belarus",
    BLZ: "Belize",
    BMU: "Bermuda",
    BOL: "Bolivia (Plurinational State of)",
    BRA: "Brazil",
    BRB: "Barbados",
    BRN: "Brunei Darussalam",
    BTN: "Bhutan",
    BVT: "Bouvet Island",
    BWA: "Botswana",
    CAF: "Central African Republic",
    CAN: "Canada",
    CCK: "Cocos (Keeling) Islands",
    CHE: "Switzerland",
    CHL: "Chile",
    CHN: "China",
    CIV: "Côte d'Ivoire",
    CMR: "Cameroon",
    COD: "Congo (Democratic Republic of the)",
    COG: "Congo",
    COK: "Cook Islands",
    COL: "Colombia",
    COM: "Comoros",
    CPV: "Cabo Verde",
    CRI: "Costa Rica",
    CUB: "Cuba",
    CUW: "Curaçao",
    CXR: "Christmas Island",
    CYM: "Cayman Islands",
    CYP: "Cyprus",
    CZE: "Czech Republic",
    DEU: "Germany",
    DJI: "Djibouti",
    DMA: "Dominica",
    DNK: "Denmark",
    DOM: "Dominican Republic",
    DZA: "Algeria",
    ECU: "Ecuador",
    EGY: "Egypt",
    ERI: "Eritrea",
    ESH: "Western Sahara",
    ESP: "Spain",
    EST: "Estonia",
    ETH: "Ethiopia",
    FIN: "Finland",
    FJI: "Fiji",
    FLK: "Falkland Islands (Malvinas)",
    FRA: "France",
    FRO: "Faroe Islands",
    FSM: "Micronesia (Federated States of)",
    GAB: "Gabon",
    GBR: "United Kingdom of Great Britain and Northern Ireland",
    GEO: "Georgia",
    GGY: "Guernsey",
    GHA: "Ghana",
    GIB: "Gibraltar",
    GIN: "Guinea",
    GLP: "Guadeloupe",
    GMB: "Gambia",
    GNB: "Guinea-Bissau",
    GNQ: "Equatorial Guinea",
    GRC: "Greece",
    GRD: "Grenada",
    GRL: "Greenland",
    GTM: "Guatemala",
    GUF: "French Guiana",
    GUM: "Guam",
    GUY: "Guyana",
    HKG: "Hong Kong",
    HMD: "Heard Island and McDonald Islands",
    HND: "Honduras",
    HRV: "Croatia",
    HTI: "Haiti",
    HUN: "Hungary",
    IDN: "Indonesia",
    IMN: "Isle of Man",
    IND: "India",
    IOT: "British Indian Ocean Territory",
    IRL: "Ireland",
    IRN: "Iran (Islamic Republic of)",
    IRQ: "Iraq",
    ISL: "Iceland",
    ISR: "Israel",
    ITA: "Italy",
    JAM: "Jamaica",
    JEY: "Jersey",
    JOR: "Jordan",
    JPN: "Japan",
    KAZ: "Kazakhstan",
    KEN: "Kenya",
    KGZ: "Kyrgyzstan",
    KHM: "Cambodia",
    KIR: "Kiribati",
    KNA: "Saint Kitts and Nevis",
    KOR: "Korea (Republic of)",
    KWT: "Kuwait",
    LAO: "Lao People's Democratic Republic",
    LBN: "Lebanon",
    LBR: "Liberia",
    LBY: "Libya",
    LCA: "Saint Lucia",
    LIE: "Liechtenstein",
    LKA: "Sri Lanka",
    LSO: "Lesotho",
    LTU: "Lithuania",
    LUX: "Luxembourg",
    LVA: "Latvia",
    MAC: "Macao",
    MAF: "Saint Martin (French part)",
    MAR: "Morocco",
    MCO: "Monaco",
    MDA: "Moldova (Republic of)",
    MDG: "Madagascar",
    MDV: "Maldives",
    MEX: "Mexico",
    MHL: "Marshall Islands",
    MKD: "Macedonia (the former Yugoslav Republic of)",
    MLI: "Mali",
    MLT: "Malta",
    MMR: "Myanmar",
    MNE: "Montenegro",
    MNG: "Mongolia",
    MNP: "Northern Mariana Islands",
    MOZ: "Mozambique",
    MRT: "Mauritania",
    MSR: "Montserrat",
    MTQ: "Martinique",
    MUS: "Mauritius",
    MWI: "Malawi",
    MYS: "Malaysia",
    MYT: "Mayotte",
    NAM: "Namibia",
    NCL: "New Caledonia",
    NER: "Niger",
    NFK: "Norfolk Island",
    NGA: "Nigeria",
    NIC: "Nicaragua",
    NIU: "Niue",
    NLD: "Netherlands",
    NOR: "Norway",
    NPL: "Nepal",
    NRU: "Nauru",
    NZL: "New Zealand",
    OMN: "Oman",
    PAK: "Pakistan",
    PAN: "Panama",
    PCN: "Pitcairn",
    PER: "Peru",
    PHL: "Philippines",
    PLW: "Palau",
    PNG: "Papua New Guinea",
    POL: "Poland",
    PRK: "Korea (Democratic People's Republic of)",
    PRT: "Portugal",
    PRY: "Paraguay",
    PSE: "Palestine (State of)",
    PYF: "French Polynesia",
    QAT: "Qatar",
    REU: "Réunion",
    ROU: "Romania",
    RUS: "Russian Federation",
    RWA: "Rwanda",
    SAU: "Saudi Arabia",
    SDN: "Sudan",
    SEN: "Senegal",
    SGP: "Singapore",
    SGS: "South Georgia and the South Sandwich Islands",
    SHN: "Saint Helena (Ascension and Tristan da Cunha)",
    SJM: "Svalbard and Jan Mayen",
    SLB: "Solomon Islands",
    SLE: "Sierra Leone",
    SLV: "El Salvador",
    SMR: "San Marino",
    SOM: "Somalia",
    SPM: "Saint Pierre and Miquelon",
    SRB: "Serbia",
    SSD: "South Sudan",
    STP: "Sao Tome and Principe",
    SUR: "Suriname",
    SVK: "Slovakia",
    SVN: "Slovenia",
    SWE: "Sweden",
    SWZ: "Swaziland",
    SXM: "Sint Maarten (Dutch part)",
    SYC: "Seychelles",
    SYR: "Syrian Arab Republic",
    TCA: "Turks and Caicos Islands",
    TCD: "Chad",
    TGO: "Togo",
    THA: "Thailand",
    TJK: "Tajikistan",
    TKL: "Tokelau",
    TKM: "Turkmenistan",
    TLS: "Timor-Leste",
    TON: "Tonga",
    TTO: "Trinidad and Tobago",
    TUN: "Tunisia",
    TUR: "Turkey",
    TUV: "Tuvalu",
    TWN: "Taiwan",
    TZA: "Tanzania (United Republic of)",
    UGA: "Uganda",
    UKR: "Ukraine",
    UMI: "United States Minor Outlying Islands",
    URY: "Uruguay",
    USA: "United States of America",
    UZB: "Uzbekistan",
    VAT: "Holy See",
    VCT: "Saint Vincent and the Grenadines",
    VEN: "Venezuela (Bolivarian Republic of)",
    VGB: "Virgin Islands (British)",
    VIR: "Virgin Islands (U.S.)",
    VNM: "Vietnam",
    VUT: "Vanuatu",
    WLF: "Wallis and Futuna",
    WSM: "Samoa",
    YEM: "Yemen",
    ZAF: "South Africa",
    ZMB: "Zambia",
    ZWE: "Zimbabwe",
};
export const US_STATE_OPTIONS = [
    "AA",
    "AE",
    "AK",
    "AL",
    "AP",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "GU",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MI",
    "MN",
    "MO",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VI",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY",
];
/**
 * the ineligibility statuses will show with the following priority:
 * 1. INELIGIBLE_REGION
 * 2. INELIGIBLE_ACCOUNT_TYPE
 * 3. INSUFFICIENT_BALANCE
 * 4. INELIGIBLE_SUITABILITY
 */
export var FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS;
(function (FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS) {
    FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS["ELIGIBLE"] = "ELIGIBLE";
    FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS["INELIGIBLE_REGION"] = "INELIGIBLE_REGION";
    FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS["INELIGIBLE_ACCOUNT_TYPE"] = "INELIGIBLE_ACCOUNT_TYPE";
    FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS["INSUFFICIENT_BALANCE"] = "INSUFFICIENT_BALANCE";
    FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS["INELIGIBLE_SUITABILITY"] = "INELIGIBLE_SUITABILITY";
})(FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS || (FULLY_PAID_SECURITIES_LENDING_ELIGIBILITY_STATUS = {}));
export var INVESTMENT_EXPERIENCES;
(function (INVESTMENT_EXPERIENCES) {
    INVESTMENT_EXPERIENCES["LIMITED"] = "LIMITED";
    INVESTMENT_EXPERIENCES["GOOD"] = "GOOD";
    INVESTMENT_EXPERIENCES["EXTENSIVE"] = "EXTENSIVE";
})(INVESTMENT_EXPERIENCES || (INVESTMENT_EXPERIENCES = {}));
export var IRA_DISTRIBUTION_REASONS;
(function (IRA_DISTRIBUTION_REASONS) {
    IRA_DISTRIBUTION_REASONS["CONVERSION"] = "CONVERSION";
    IRA_DISTRIBUTION_REASONS["DEATH"] = "DEATH";
    IRA_DISTRIBUTION_REASONS["EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE"] = "EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE";
    IRA_DISTRIBUTION_REASONS["EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE"] = "EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE";
    IRA_DISTRIBUTION_REASONS["NORMAL"] = "NORMAL";
    IRA_DISTRIBUTION_REASONS["PREMATURE"] = "PREMATURE";
    IRA_DISTRIBUTION_REASONS["RECHARACTERIZATION_PRIOR_YEAR"] = "RECHARACTERIZATION_PRIOR_YEAR";
    IRA_DISTRIBUTION_REASONS["RECHARACTERIZATION_CURRENT_YEAR"] = "RECHARACTERIZATION_CURRENT_YEAR";
    IRA_DISTRIBUTION_REASONS["TRANSFER"] = "TRANSFER";
})(IRA_DISTRIBUTION_REASONS || (IRA_DISTRIBUTION_REASONS = {}));
export var IRA_CONTRIBUTION_REASONS;
(function (IRA_CONTRIBUTION_REASONS) {
    IRA_CONTRIBUTION_REASONS["CONVERSION"] = "CONVERSION";
    IRA_CONTRIBUTION_REASONS["EMPLOYEE"] = "EMPLOYEE";
    IRA_CONTRIBUTION_REASONS["EMPLOYER"] = "EMPLOYER";
    IRA_CONTRIBUTION_REASONS["RECHARACTERIZATION"] = "RECHARACTERIZATION";
    IRA_CONTRIBUTION_REASONS["REGULAR"] = "REGULAR";
    IRA_CONTRIBUTION_REASONS["ROLLOVER_60_DAY"] = "ROLLOVER_60_DAY";
    IRA_CONTRIBUTION_REASONS["ROLLOVER_DIRECT"] = "ROLLOVER_DIRECT";
    IRA_CONTRIBUTION_REASONS["TRANSFER"] = "TRANSFER";
})(IRA_CONTRIBUTION_REASONS || (IRA_CONTRIBUTION_REASONS = {}));
export var LIQUIDITY_NEEDS;
(function (LIQUIDITY_NEEDS) {
    LIQUIDITY_NEEDS["VERY_IMPORTANT"] = "VERY_IMPORTANT";
    LIQUIDITY_NEEDS["SOMEWHAT_IMPORTANT"] = "SOMEWHAT_IMPORTANT";
    LIQUIDITY_NEEDS["NOT_IMPORTANT"] = "NOT_IMPORTANT";
})(LIQUIDITY_NEEDS || (LIQUIDITY_NEEDS = {}));
export var RECURRING_DEPOSIT_STATUSES;
(function (RECURRING_DEPOSIT_STATUSES) {
    RECURRING_DEPOSIT_STATUSES["ACTIVE"] = "Active";
    RECURRING_DEPOSIT_STATUSES["CANCELED"] = "Canceled";
    RECURRING_DEPOSIT_STATUSES["COMPLETE"] = "Complete";
    RECURRING_DEPOSIT_STATUSES["PRE_SEND"] = "Pre-Send";
    RECURRING_DEPOSIT_STATUSES["SEND_FAILED"] = "Send Failed";
})(RECURRING_DEPOSIT_STATUSES || (RECURRING_DEPOSIT_STATUSES = {}));
export var TRADING_REQUEST_TYPES;
(function (TRADING_REQUEST_TYPES) {
    TRADING_REQUEST_TYPES["CRYPTOCURRENCY_TRADING"] = "Cryptocurrency Trading";
    TRADING_REQUEST_TYPES["EQUITY_OFFERING"] = "Equity Offering";
    TRADING_REQUEST_TYPES["INTRADAY_FUTURES_MARGIN"] = "Intraday Futures Margin";
    TRADING_REQUEST_TYPES["IRA_SHORT_CALL"] = "IRA Short Call";
    TRADING_REQUEST_TYPES["PORTFOLIO_MARGIN"] = "Portfolio Margin";
})(TRADING_REQUEST_TYPES || (TRADING_REQUEST_TYPES = {}));
export var TRANSFER_METHODS;
(function (TRANSFER_METHODS) {
    TRANSFER_METHODS["BLANK"] = "";
    TRANSFER_METHODS["ACH"] = "ACH";
    TRANSFER_METHODS["RTP"] = "RTP";
    TRANSFER_METHODS["WIRE"] = "WIRE";
    TRANSFER_METHODS["CHECK"] = "CHECK";
    TRANSFER_METHODS["STABLECOIN"] = "STABLECOIN";
})(TRANSFER_METHODS || (TRANSFER_METHODS = {}));
export var TAX_DOCUMENT_SLUGS;
(function (TAX_DOCUMENT_SLUGS) {
    TAX_DOCUMENT_SLUGS["IRS_1042_S_TAX"] = "irs_1042_s_tax";
    TAX_DOCUMENT_SLUGS["IRS_1099_TAX"] = "irs_1099_tax";
    TAX_DOCUMENT_SLUGS["IRS_1099B_CRYPTOCURRENCIES_TAX"] = "irs_1099b_cryptocurrencies_tax";
    TAX_DOCUMENT_SLUGS["IRS_1099B_TAX"] = "irs_1099b_tax";
    TAX_DOCUMENT_SLUGS["IRS_1099R_TAX"] = "irs_1099r_tax";
    TAX_DOCUMENT_SLUGS["IRS_5498_TAX"] = "irs_5498_tax";
    TAX_DOCUMENT_SLUGS["IRS_1099DA_TAX"] = "irs_1099da_tax";
})(TAX_DOCUMENT_SLUGS || (TAX_DOCUMENT_SLUGS = {}));
export var TAX_WORKSHEET_SLUGS;
(function (TAX_WORKSHEET_SLUGS) {
    TAX_WORKSHEET_SLUGS["GAIN_LOSS_TAX_WORKSHEET"] = "gain_loss_tax_worksheet";
    TAX_WORKSHEET_SLUGS["NO_WASH_SALES_TAX_WORKSHEET"] = "no_wash_sales_tax_worksheet";
    TAX_WORKSHEET_SLUGS["WITH_WASH_SALES_TAX_WORKSHEET"] = "with_wash_sales_tax_worksheet";
})(TAX_WORKSHEET_SLUGS || (TAX_WORKSHEET_SLUGS = {}));
export var TRANSFER_TYPE;
(function (TRANSFER_TYPE) {
    TRANSFER_TYPE["PARTIAL"] = "PARTIAL_TRANSFER_RECEIVER";
    TRANSFER_TYPE["FULL"] = "FULL_TRANSFER";
})(TRANSFER_TYPE || (TRANSFER_TYPE = {}));
export var TWO_FACTOR_TYPE;
(function (TWO_FACTOR_TYPE) {
    TWO_FACTOR_TYPE["AUTHENTICATOR"] = "authenticator";
    TWO_FACTOR_TYPE["EMAIL"] = "email";
    TWO_FACTOR_TYPE["SMS"] = "sms";
})(TWO_FACTOR_TYPE || (TWO_FACTOR_TYPE = {}));
export var USER_TEAM_ROLE;
(function (USER_TEAM_ROLE) {
    USER_TEAM_ROLE["OWNER"] = "owner";
    USER_TEAM_ROLE["MEMBER"] = "member";
})(USER_TEAM_ROLE || (USER_TEAM_ROLE = {}));
//# sourceMappingURL=constants.js.map